import React from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    
    // Store error info in state for display
    this.setState({
      errorInfo: errorInfo
    });

    // Check if it's a timeout error - handle it gracefully
    if (error?.message?.includes('timeout') || 
        error?.message?.includes('Timeout') ||
        error?.code === 'ECONNABORTED') {
      // Timeout errors are already handled in callApi, so we can reset
      // This prevents the error boundary from catching handled timeout errors
      setTimeout(() => {
        this.setState({ hasError: false, error: null, errorInfo: null });
      }, 100);
      return;
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    // Optionally reload the page to ensure clean state
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // Check if it's a timeout error - don't show error boundary UI
      const isTimeoutError = this.state.error?.message?.includes('timeout') || 
                            this.state.error?.message?.includes('Timeout') ||
                            this.state.error?.code === 'ECONNABORTED';

      if (isTimeoutError) {
        // Timeout errors are handled elsewhere, just reset state
        return this.props.children;
      }

      // Render custom error UI for other errors
      return (
        <div 
          style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center', 
            minHeight: '100vh',
            padding: '20px',
            backgroundColor: '#f8f9fa'
          }}
        >
          <div 
            style={{ 
              maxWidth: '600px', 
              textAlign: 'center',
              backgroundColor: 'white',
              padding: '40px',
              borderRadius: '10px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          >
            <h2 style={{ color: '#921d1e', marginBottom: '20px' }}>
              Something went wrong
            </h2>
            <p style={{ color: '#666', marginBottom: '30px' }}>
              An unexpected error occurred. Your progress has been saved. 
              Please try refreshing the page or contact support if the problem persists.
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <Button 
                variant="primary" 
                onClick={this.handleReset}
                style={{ backgroundColor: '#921d1e', border: 'none' }}
              >
                Reload Page
              </Button>
              <Button 
                variant="outline-secondary" 
                onClick={() => window.history.back()}
              >
                Go Back
              </Button>
            </div>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details style={{ marginTop: '30px', textAlign: 'left' }}>
                <summary style={{ cursor: 'pointer', color: '#921d1e' }}>
                  Error Details (Development Only)
                </summary>
                <pre style={{ 
                  marginTop: '10px', 
                  padding: '15px', 
                  backgroundColor: '#f8f9fa', 
                  borderRadius: '5px',
                  overflow: 'auto',
                  fontSize: '12px'
                }}>
                  {this.state.error.toString()}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;






